import type { FC } from "react";
import { CheckboxInputField } from "@/components/podkit/checkbox/CheckboxInputField";
import { Input } from "@/components/podkit/forms/Input";
import { InputField } from "@/components/podkit/forms/InputField";
import { Textarea } from "@/components/podkit/forms/Textarea";
import type { PropsWithClassName } from "@/components/podkit/lib/cn";
import { useAtom, type PrimitiveAtom } from "jotai";
import type { DraftPullRequestStep } from "@/routes/automations/automation-details-page/state";

export const AutomationPullRequestStepEditor: FC<{ draft: DraftPullRequestStep }> = ({ draft }) => {
    return (
        <div className="flex flex-col gap-4">
            <TitleInputField titleAtom={draft.title} />
            <DescriptionInputField descriptionAtom={draft.description} />
            <BranchInputField branchAtom={draft.branch} className="flex-1" />
            <DraftCheckboxInputField isDraftAtom={draft.isDraft} />
        </div>
    );
};

const TitleInputField: FC<{ titleAtom: PrimitiveAtom<string> }> = ({ titleAtom }) => {
    const [title, setTitle] = useAtom(titleAtom);
    return (
        <InputField label="Title">
            <Input
                className="w-full max-w-full"
                type="text"
                value={title}
                placeholder=""
                onChange={(e) => setTitle(e.target.value)}
            />
        </InputField>
    );
};

const DescriptionInputField: FC<{ descriptionAtom: PrimitiveAtom<string> }> = ({ descriptionAtom }) => {
    const [description, setDescription] = useAtom(descriptionAtom);
    return (
        <InputField label="Description">
            <Textarea
                value={description}
                placeholder=""
                onChange={(e) => setDescription(e.target.value)}
                className="resize-none"
                minHeight={150}
                maxHeight={150}
            />
        </InputField>
    );
};

const BranchInputField: FC<PropsWithClassName<{ branchAtom: PrimitiveAtom<string> }>> = ({ branchAtom, className }) => {
    const [branch, setBranch] = useAtom(branchAtom);
    return (
        <InputField label="Branch" className={className}>
            <Input
                className="w-full max-w-full"
                type="text"
                value={branch}
                placeholder=""
                onChange={(e) => setBranch(e.target.value)}
            />
        </InputField>
    );
};

export const DraftCheckboxInputField: FC<{ isDraftAtom: PrimitiveAtom<boolean> }> = ({ isDraftAtom }) => {
    const [isDraft, setIsDraft] = useAtom(isDraftAtom);
    return (
        <CheckboxInputField label="Open PR as draft" checked={isDraft} onChange={(checked) => setIsDraft(checked)} />
    );
};
